
export const FORM_EDITOR_INIT = {
  height: 650,
  mobile: {
    menubar: false,
  },
  plugins: [
    "anchor",
    "autolink",
    "charmap",
    "codesample",
    "emoticons",
    "image",
    "link",
    "lists",
    "media",
    "searchreplace",
    "table",
    "visualblocks",
    "wordcount",
  ],

  content_style: `
              .container {
                max-width: 800px;
                margin: 40px auto;
                padding: 20px;
                background-color: white;
              }
              h1 {
                text-align: center;
                color: #7244d5;
                font-weight: 600;
              }
              h2,
              h3 {
                color: #7244d5;
                margin-top: 20px;
                text-align: left;
              }
              .info-section {
                 display: flex;
                 justify-content: space-between;
                 margin-bottom: 10px;
                 padding-bottom: 20px;
                 border-bottom: 1px solid #e6e6e6;
              }
              .info-section label{
                font-weight: bold;
                color: #333;
              }
              .section {
                margin-bottom: 20px;
                border-bottom: 1px solid #e6e6e6;
              }

              .section label {
                font-weight: bold;
                color: #333;
              }
              .section div {
                margin-bottom: 10px;
                font-size: 14px;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 10px;
              }
              table,
              th,
              td {
                border: 1px solid #ddd;
              }
              th,
              td {
                padding: 8px;
                text-align: left;
              }
              th {
                background-color: #f1f1f1;
              }
              td {
                color: #555;
              }
              .footer {
                text-align: center;
                margin-top: 40px;
                font-size: 14px;
                color: #777;
              }
              .footer a {
                color: #7244d5;
                text-decoration: none;
                font-weight: 600;
              }
              .footer a:hover {
                text-decoration: underline;
              }
              .header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #e6e6e6;
                padding-bottom: 20px;
              }

              .address {
                width: 200px;
                font-size: small;
              }
              .follow-up-advice {
                border-bottom: none;
              }

              .custom-list li {
                 margin-bottom: 10px;
              }
              @media (max-width: 768px) {
                .container {
                  max-width: 100%;
                  margin: 0;
                  padding: 12px;
                }
                h1 {
                  font-size: 20px;
                }
                h2,
                h3 {
                  font-size: 16px;
                  margin-top: 16px;
                }
                .info-section,
                .header {
                  flex-direction: column;
                  align-items: flex-start;
                  gap: 12px;
                }
                .info-section > div,
                .header > div {
                  width: 100%;
                  min-width: 0;
                }
                .info-section > div > div,
                .section > div {
                  margin-bottom: 10px;
                  line-height: 1.5;
                  word-break: break-word;
                }
                .address {
                  width: 100%;
                }
                table {
                  display: block;
                  overflow-x: auto;
                  -webkit-overflow-scrolling: touch;
                }
                th,
                td {
                  white-space: normal;
                  word-break: break-word;
                }
              }`,

  toolbar:
    "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
};

export default FORM_EDITOR_INIT;
